var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.667 0.333374H2.33366C1.40866 0.333374 0.675326 1.07504 0.675326 2.00004L0.666992 12C0.666992 12.925 1.40866 13.6667 2.33366 13.6667H15.667C16.592 13.6667 17.3337 12.925 17.3337 12V2.00004C17.3337 1.07504 16.592 0.333374 15.667 0.333374ZM15.667 12H2.33366V7.00004H15.667V12ZM15.667 3.66671H2.33366V2.00004H15.667V3.66671Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.2b9fb5d5e70f15e4808a2f15fc804f2b.svg";
export { ForwardRef as ReactComponent };